<template>
  <div>
    <template v-if="!isMobile">
      <planning-list ref="PlanningListData"/>
    </template>
    <template v-else>
      <planning-list-mobile  ref="PlanningListMobileData" />
    </template>
  </div>
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

const PlanningList = () => import('./PlanningList')
const PlanningListMobile = () => import('./PlanningListMobile')

export default {
  name: 'Planning',

  mixins: [adaptationMixin],

  components: {
    PlanningList,
    PlanningListMobile
  },
  methods: {
    onUpdate () {
      this.$refs.PlanningListData.loadData()
    }
  }
}
</script>
